const localStorageName = 'authToken';

const useToken = () => {
  const token = localStorage.getItem(localStorageName);
  const openMenu = localStorage.getItem('openMenu');

  return {
    token,
    setToken: (tokenValue) => {
      localStorage.setItem(localStorageName, tokenValue);
    },
    removeToken: () => {
      localStorage.removeItem(localStorageName);
    },
    openMenu,
    setOpenMenu: (bool) => {
      localStorage.setItem(bool, 'openMenu');
    },
  };
};

export const token = localStorage.getItem(localStorageName);
export default useToken;
